import React, { Fragment } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import Media from 'react-media'

import { withAppContext } from '../utils/AppContext'
import SocialShareButton from './SocialShareButton'
import Share from './Share'
import ListTile from './ListTile'
import MobileIntro from './MobileIntro'

import styles from '../scss/layout/app.scss'
import fansidedLogo from '../images/fansided-logo.png'
import logo from '../images/GoTPicker-Logo__desktop.png'
import logoWhite from '../images/GoTPicker-Logo__white.png'

class Body extends React.Component {
    constructor() {
        super()
        this.state = {
            mobileIntro: false,
        }
        this.handleOnClick = this.handleOnClick.bind(this)
    }

    handleCenterContent({ appContext }) {
        if (appContext.list === false) {
            return <h2 className="center-content">Include more Houses to fill all your positions</h2>
        }
        return ''
    }

    handleOnClick() {
        this.setState({
            mobileIntro: true,
        })
    }

    render() {
        const { appContext } = this.props
        const { mobileIntro } = this.state

        return (
            <Fragment>
                {appContext.toggleShare && <Share />}
                <div className={styles.appBody}>
                    <Media query="(min-width: 415px)">
                        {matches => (matches ? (
                            <div className={cx(styles.directions, 'owl-medium')}>
                                <img src={logo} alt="Logo" />
                                <h3>PRESENTED BY</h3>
                                <img src={fansidedLogo} className={styles.fansidedLogo} alt="FanSided Logo" />
                                {this.handleCenterContent({ appContext })}
                            </div>
                        ) : (
                            <div className={styles.mobileContainer}>
                                <button onClick={this.handleOnClick} type="button">
                                    <MobileIntro classDeactive={mobileIntro} />
                                </button>
                                {this.handleCenterContent({ appContext })}
                            </div>
                        ))
                        }
                    </Media>
                    <ListTile
                        position="handScore"
                        title={(
                            <span>
                                Hand of the
                                <br /> King/Queen
                            </span>
                        )}
                    />
                    <ListTile position="coinScore" title={<span>Master of Coin</span>} className="listTileMargin" />
                    <ListTile
                        position="whispersScore"
                        title={<span>Master of Whisperers</span>}
                        className="listTileMargin"
                    />
                    <ListTile
                        position="commanderScore"
                        title={(
                            <span>
                                Lord Commander
                                <br /> of the Kingsguard
                            </span>
                        )}
                    />
                    <Media query="(min-width: 415px)">
                        {matches => (matches ? (
                            <ListTile
                                position="grandMScore"
                                title={<span>Grand Maester</span>}
                                className="listTileMargin"
                            />
                        ) : (
                            <ListTile
                                position="grandMScore"
                                title={<span>Grand Maester</span>}
                                className="listTileMarginMobile"
                            />
                        ))
                        }
                    </Media>
                    <div className={cx('vertical-middle', styles.easterEgg)}>
                        <img src={logoWhite} alt="Yeti Easter Egg" />
                        <div className={styles.easterEggText}>
                            <p className="horizontal-owl">
                                Share your Small Council and invite your friends to build their own
                            </p>
                            <SocialShareButton
                                onClick={() => appContext.toggleShareLightboxOn()}
                                iconSize={2}
                                color="white"
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

Body.propTypes = {
    appContext: PropTypes.object.isRequired,
}

export default withAppContext(Body)



// WEBPACK FOOTER //
// ./src/ui/Body.js